import utils from '../utils/utils'
import globalVar from '../utils/globalVar'
import scrollTo from '../utils/helpers/scrollTo'

class Nav {
  constructor() {
    let cache = {};
    let initFunc = () => {
      initCache();
      registerEvents();
    }

    let initCache = () => {
      cache.nav = document.querySelector('.nav');
      cache.navmobileBtn = document.querySelector('.nav_mobile');
      cache.navmobile = document.querySelector('.mobile-menu');
    };

    let registerEvents = () => {
      if (cache.navmobileBtn) {
        cache.navmobileBtn.addEventListener("click", toggleNav);
      }
    };

    let toggleNav = () => {
      if (cache.navmobileBtn.classList.contains('active')) {
        closeNav();
      } else {
        openNav();
      }
    }

    let openNav = () => {
      cache.navmobileBtn.classList.add('active');
      cache.navmobile.classList.add('active');
      document.querySelector('body').classList.add('overflow');
      document.querySelector('html').classList.add('overflow');
    }

    let closeNav = () => {
      cache.navmobileBtn.classList.remove('active');
      cache.navmobile.classList.remove('active');
      document.querySelector('body').classList.remove('overflow');
      document.querySelector('html').classList.remove('overflow');
    }

    initFunc();
  };
}
export { Nav }
